import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@ozpanel/ui";

// Which Caddy plugins the RUNNING binary carries, keyed by feature (GET /caddy/plugins, readable by an
// account admin as well as the platform). null: the server could not read its own module list; a key
// absent from the map: the catalog itself could not be read. Neither is "built in" — the site form
// labelled every switch "in build" whenever it did not know (the route answered 403 to customers).
export type PluginAvailability = Record<string, boolean | null>;

export function usePluginAvailability(): PluginAvailability {
  const { client } = useAuth();
  const plugins = useQuery({
    queryKey: ["caddy-plugins"],
    queryFn: () => client.apiFetch<{ items: { key: string; available: boolean | null }[] | null }>("/caddy/plugins"),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  return React.useMemo(() => {
    const m: PluginAvailability = {};
    for (const p of plugins.data?.items ?? []) m[p.key] = p.available;
    return m;
  }, [plugins.data]);
}
